import React from "react";
import { Button } from "../ui/button";

const HeroSection = () => {
  const handleGetStarted = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  const handleBookCall = () => {
    // Mock booking call action
    alert("Booking call functionality - this would redirect to calendar booking");
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30" 
           style={{backgroundImage: "url('https://images.unsplash.com/photo-1639762681485-074b7f938ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2832&q=80')"}}></div>
      
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black opacity-80"></div>
      
      {/* Geometric Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 border border-yellow-400/20 transform rotate-45"></div>
        <div className="absolute top-1/3 right-1/4 w-48 h-48 border border-yellow-400/20 transform rotate-12"></div>
        <div className="absolute bottom-1/4 left-1/3 w-32 h-32 border border-yellow-400/20 transform -rotate-45"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 text-center">
        {/* Subtitle */}
        <p className="text-yellow-400 text-lg md:text-xl mb-6 font-medium">
          The Marketing Revolution
        </p>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
          Close More Deals with{" "}
          <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
            Smart
          </span>{" "}
          Automation
        </h1>

        {/* Description */}
        <p className="text-gray-300 text-lg md:text-xl mb-12 max-w-3xl mx-auto leading-relaxed">
          A 24/7 growth engine that captures leads, nurtures buyers, and fills your calendar with appointments.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={handleGetStarted}
            className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
          >
            Get Started
          </Button>
          <Button
            onClick={handleBookCall}
            variant="outline"
            className="border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
          >
            Book A Call
          </Button>
        </div>
      </div>

      {/* Animated scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-yellow-400 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-yellow-400 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;